import Backbone from 'backbone';
import { PUB_SUB_EVENTS, subscribe, publish } from '@/lib/pubsub';
import { postRequests } from '@/service/requests';

const OneCartView = Backbone.View.extend({
  initialize: function (settings) {
    this.unsubscribe = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      this.handleCartUpdate.bind(this)
    );
  },

  events: {
    'click .item-remove': 'handleRemoveItem',
    'change .item-quantity input': 'handleQuantityChange',
    'click .item-quantity button': 'handleQuantityButtonClick'
  },

  /**
   * Request updated cart HTML from Shopify Section Rendering API and replace the
   * current cart HTML with the new HTML
   */
  handleCartUpdate: async function () {
    const mainContent = document.querySelector('#MainContent');
    const MainSection = mainContent.firstElementChild;
    const maindIdFormatted = MainSection.id.replace('shopify-section-', '');
    this.updateCartContent(maindIdFormatted);

    if (this.error) {
      const { id, message } = this.error;
      this.showError(id, message);
    }
  },
  updateCartContent: async function (sectionId) {
    fetch(`/?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(html, 'text/html');

        const newSection = newDocument.querySelector(
          `#shopify-section-${sectionId}`
        );

        const currentSection = document.querySelector(
          `#shopify-section-${sectionId}`
        );
        if (currentSection && newSection) {
          currentSection.innerHTML = newSection.innerHTML;
        }
      })
      .catch((error) => {
        console.error('Error on update section:', error);
      });
  },

  /**
   * Handle click events on "remove item" buttons
   * @param {Event} e A click event
   */
  handleRemoveItem: async function (e) {
    e.preventDefault();
    const cartItemElem = e.currentTarget.closest('.cart-item');
    this.updateQuantity(cartItemElem.dataset.lineItemKey, 0);
  },

  /**
   * Start timer to send update request and reset timer if another change event
   * occurs before the timer is up
   * @param {Event} e A change event
   */
  handleQuantityChange: function (e) {
    if (this.timeout) clearTimeout(this.timeout);
    const onTimeout = (_) => {
      this.updateQuantity(e.currentTarget.dataset.id, e.currentTarget.value);
    };
    this.timeout = setTimeout(onTimeout.bind(this), 1000);
  },

  /**
   * Request to update cart item quantity and update relevant info
   * @param {String} id The cart item's variant ID
   * @param {Number} quantity The cart item's new quantity
   */
  updateQuantity: async function (id, quantity) {
    this.setLoading(id);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`
      }
    };
    const res = await postRequests(ORW.routes.cartChangeURL, {
      id,
      quantity,
      config
    });
    publish(PUB_SUB_EVENTS.cartUpdate, {});
    if (res.errors) {
      this.error = {
        id,
        message: res.errors.trim()
      };
    }
  },

  /**
   * Update the quantity input value based on the button clicked and dispatch a
   * change event
   * @param {Event} e A click event
   */
  handleQuantityButtonClick: function (e) {
    const input = e.currentTarget
      .closest('.item-quantity')
      .querySelector('input');
    e.currentTarget.name === 'plus' ? input.stepUp() : input.stepDown();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  },

  /**
   * Hide prices and show loading spinner for a cart item and the cart subtotal
   * @param {String} id The line item ID of the cart item
   */
  setLoading: function (id) {
    const subtotal = this.el.querySelector('.total-price');
    subtotal.querySelector('span').style.display = 'none';
    subtotal.querySelector('.spinner').style.display = 'block';

    const item = this.el.querySelector(`[data-line-item-key="${id}"]`);
    item.querySelector('.item-total span').style.display = 'none';
    item.querySelector('.item-total .spinner').style.display = 'block';
  },

  showError: function (id, message) {
    const item = this.el.querySelector(`[data-id="${id}"]`);
    const error = item.querySelector('.item-error');
    console.log(error, message);
    error.textContent = message;
  },

  destroy: function () {
    this.unsubscribe();
  }
});

export default OneCartView;
